var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconreferActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#FAAA52"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7736 9.901L11.3621 12.0959C11.1951 12.2471 10.938 12.2358 10.7868 12.0689C10.7192 11.9944 10.6808 11.8952 10.6808 11.7936V11.1282H9.70178C9.09721 11.1282 8.49716 11.5387 8.04825 12.2561L7.68281 13.0298C7.61513 13.172 7.47301 13.2622 7.31511 13.2644C7.28578 13.2644 7.2542 13.2622 7.22487 13.2554C7.03989 13.2126 6.9068 13.0479 6.9068 12.8584C6.9068 10.1198 8.1836 8.13017 9.94315 8.13017H10.6831V7.40831C10.6831 7.18272 10.8658 7 11.0891 7C11.1906 7 11.2899 7.03835 11.3643 7.10602L13.7736 9.29869C13.9405 9.44983 13.9518 9.70926 13.8006 9.87393C13.7916 9.88521 13.7826 9.89423 13.7736 9.901Z",
    fill: "#FFEFDE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconreferActive);
export default __webpack_public_path__ + "static/media/Icon.referActive.cc0cdc31bab858bd3e1cfe289414e133.svg";
export { ForwardRef as ReactComponent };